import { render } from "./ScientificInformationCardRow.vue?vue&type=template&id=c0c5df76&scoped=true"
import script from "./ScientificInformationCardRow.vue?vue&type=script&lang=js"
export * from "./ScientificInformationCardRow.vue?vue&type=script&lang=js"

import "./ScientificInformationCardRow.vue?vue&type=style&index=0&id=c0c5df76&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0c5df76"]])

export default __exports__